import APIService from "./APIService.js";

/**
 * API service for notification management
 */
class NotificationAPI {
  /**
   * Get all notifications for a user
   */
  static async getUserNotifications() {
    try {
      return await APIService.get(`/api/v1/app/notifications/user`);
    } catch (error) {
      console.error("Error fetching user notifications:", error);
      throw error;
    }
  }

  /**
   * Get unread notifications for a user
   */
  static async getUnreadNotifications() {
    try {
      return await APIService.get(`/api/v1/app/notifications/user/unread`);
    } catch (error) {
      console.error("Error fetching unread notifications:", error);
      throw error;
    }
  }

  /**
   * Get notification counts for a user
   */
  static async getNotificationCounts() {
    try {
      return await APIService.get(`/api/v1/app/notifications/user/counts`);
    } catch (error) {
      console.error("Error fetching notification counts:", error);
      throw error;
    }
  }

  /**
   * Mark notifications as read
   */
  static async markAsRead(userUuid, notificationIds) {
    try {
      return await APIService.put(
        `/api/v1/app/notifications/user/mark-read`,
        notificationIds
      );
    } catch (error) {
      console.error("Error marking notifications as read:", error);
      throw error;
    }
  }

  /**
   * Mark all notifications as read
   */
  static async markAllAsRead(userUuid) {
    try {
      return await APIService.put(
        `/api/v1/app/notifications/user/mark-all-read`,
        {}
      );
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
      throw error;
    }
  }

  /**
   * Dismiss notifications
   */
  static async dismissNotifications(userUuid, notificationIds) {
    try {
      return await APIService.put(
        `/api/v1/app/notifications/user/dismiss`,
        notificationIds
      );
    } catch (error) {
      console.error("Error dismissing notifications:", error);
      throw error;
    }
  }

  /**
   * Get a specific notification by ID
   */
  static async getNotificationById(userUuid, notificationId) {
    try {
      return await APIService.get(
        `/api/v1/app/notifications/user/notification/${notificationId}`
      );
    } catch (error) {
      // Handle 404 specifically
      if (error.response && error.response.status === 404) {
        return null;
      }
      console.error("Error fetching notification by ID:", error);
      throw error;
    }
  }

  /**
   * Create a new notification (admin only)
   */
  static async createNotification(userUuid, notification) {
    try {
      return await APIService.post(
        `/api/v1/app/notifications/user`,
        notification
      );
    } catch (error) {
      console.error("Error creating notification:", error);
      throw error;
    }
  }
}

export default NotificationAPI;
